import React from 'react'
import {findDOMNode} from "react-dom"

import Board_ColumnHeader_ShowTotal from "../more/total/show-total-popover"
import Board_Manager from "../../managers/manager"
import Popover from "../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position"
import HintPopover from "../../../../../gd-ui/hint-popover/hint-popover"

export type AggregateShellProps = {
    className?      : string

    manager         : Board_Manager

    hint?           : string

    showOnHover?    : boolean

    children?       : any
}

type State = {
    showPopover : boolean
    useHint     : boolean
}

// const debug = "Board_AggregateShell"
const debug = false

export default class Board_AggregateShell extends React.Component<AggregateShellProps, State> {

    constructor(props: AggregateShellProps) {
        super(props)

        this.state = {
            showPopover : false,
            useHint     : false
        }
    }

    componentDidMount() {
        this._checkHintUsage()
    }

    componentDidUpdate() {
        this._checkHintUsage()
    }

    _checkHintUsage = () => {
        if (!this.props.hint) {
            return
        }

        const node:any = findDOMNode(this)
        if (!node) {
            return;
        }

        const textWidth = gd.utils.getTextWidth(this.props.hint, 13) + 17 /*icon width + margin*/ + 10 /*paddings*/
        const useHint = node.clientWidth < textWidth

        debug && console.log(debug, '_checkHintUsage', useHint, node.clientWidth, textWidth)

        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    }

    onClickOutside = (e?:React.SyntheticEvent) => {
        if(e && gd.utils.Dom.findNodeByClassName(e.target, ['gd-popover-add-column-new', 'ui5-popover-menu'])) {
            return
        }

        this.hidePopover()
    }

    onTogglePopover = (e: React.SyntheticEvent) => {
        e.stopPropagation()

        this.setState({
            showPopover: !this.state.showPopover
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover: false
        })
    }

    render() {

        const showHint      = this.state.useHint

        const classes = Classes("ui5-control-button s-24 p-l-5 p-r-5", this.props.className, {
            'show-popover'  : this.state.showPopover,
        })

        return (
            <div className  = {classes}
                 onClick    = {this.onTogglePopover}>

                {this.props.children}

                {this.state.showPopover &&
                    <Popover
                        position                = {PopoverPosition.bottomLeftHorizontal()}
                        arrowsVersion           = {2}
                        onClickOutside          = {this.onClickOutside}
                        getTargetFunc           = {()=>findDOMNode(this)}
                    >
                        <Board_ColumnHeader_ShowTotal
                            manager     = {this.props.manager}
                            hidePopover = {this.hidePopover}
                        />
                    </Popover>}

                {showHint &&
                    <HintPopover
                        hint        = {this.props.hint}
                        multiline   = {true}
                        showDelay   = {500}
                    />}
            </div>
        );
    }
}